
// function extractYouTubeVideoId(url) {
//   if(null == url)
//     return "";

//   let videoId = null;
//   // YouTube URL의 다양한 형식을 고려하여 정규 표현식을 사용하여 동영상 ID 추출
//   const patterns = [
//     /(?:\?v=|\/embed\/|\/v\/|\/vi\/|\/watch\?v=|\/watch\?feature=player_embedded&v=)([A-Za-z0-9_-]{11})/,
//     /^([A-Za-z0-9_-]{11})$/
//   ];

//   for (const pattern of patterns) {
//     const match = url.match(pattern);
//     if (match && match[1]) {
//       videoId = match[1];
//       break;
//     }
//   }

//   return videoId;
// }

function extractYouTubeVideoId(url) {
  if (url == null) url = "";

  var id = '';
  url = url.trim();
  url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/live\/)/);
  if (url[2] !== undefined) {
    id = url[2].split(/[^0-9a-z_-]/i);
    id = id[0];
  } else {
    id = url;
  }
  return id;
}

// 테스트
// const youtubeURL = "https://www.youtube.com/watch?v=VIDEO_ID_HERE";
// const videoId = extractYouTubeVideoId(youtubeURL);
// console.log("YouTube Video ID: " + videoId);

export { extractYouTubeVideoId };
